"use client";

import * as React from "react";
import { ThemeProvider as NextThemesProvider } from "next-themes";
import { type ThemeProviderProps } from "next-themes";

export function CustomNextThemeProvider({ children, ...props }: ThemeProviderProps) {
  return (
    <NextThemesProvider
      attribute={props.attribute || "class"}
      defaultTheme={props.defaultTheme || "dark"}
      enableSystem={props.enableSystem || false}
      disableTransitionOnChange={props.disableTransitionOnChange || false}
      storageKey={props.storageKey || "ix-theme"}
      {...props}
    >
      {children}
    </NextThemesProvider>
  );
}
